import * as React from "react";
import { Card, CardContent } from "../ui/card";
import { Download, FileText, Link } from "lucide-react";
import { useGetAssignmentsQuery } from "@/store/assignmentApi";
import { useSelector } from "react-redux";
import { AssignmentItem, RootState } from "@/types";

const StudentAssignments = () => {
  const { user } = useSelector((state: RootState) => state.user);

  //   Assignments
  const { data: assignment } = useGetAssignmentsQuery({
    batchCode: user?.batch._id,
    type: null,
    status: "",
  });

  return (
    <Card className="w-full mb-6">
      {/* <CardHeader className="bg-primary/5">
        <CardTitle className="flex items-center gap-2">
          <FileText className="w-5 h-5" />
          <h2 className="text-xl">Project Assignment Document</h2>
        </CardTitle>
      </CardHeader> */}
      <CardContent className="pt-6 space-y-6">
        {assignment?.data?.length ? (
          assignment.data.map((item: AssignmentItem) => {
            console.log("Assignment Item:", item?.uploadedFile);
            return (
              <div
                key={item._id}
                className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-b pb-1 last:border-none"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <FileText size={18} className=" text-blue-600" />
                  </div>

                  <div className="flex-1">
                    <h3 className="font-semibold text-base mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-2">
                      {item.description}
                    </p>

                    <div className="flex flex-col flex-wrap  text-sm text-gray-500">
                      <div className="flex gap-2">
                        <span>
                          <span className="font-semibold"> Deadline: </span>
                          {new Date(item.deadline).toLocaleDateString("en-IN", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </span>
                      </div>
                      {/* <span>•</span> */}
                      <div className="flex space-x-3 pb-2">
                        <span>
                          <span className="font-semibold"> Marks:</span>{" "}
                          {item.totalMarks}
                        </span>
                        <span>•</span>
                        <span>
                          <span className="font-semibold">Assigned by: </span>
                          {item.assignedBy?.name}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 📄 Actions */}
                <div className="flex flex-col sm:flex-row gap-2">
                  {/* View Uploaded File */}
                  {item.uploadedFile && (
                    <a
                      href={item.uploadedFile}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 bg-foreground text-background px-3 py-1.5 text-sm rounded-md hover:bg-primary/90 transition"
                    >
                      <FileText size={15} />
                      View File
                    </a>
                  )}

                  {/* 🔗 Open Task Link */}
                  {item.link && (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 border border-gray-300 px-3 py-1.5 text-sm rounded-md hover:bg-gray-100 transition"
                    >
                      <Link size={15} />
                      Open Link
                    </a>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center text-gray-500 py-6">
            No assignments available.
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StudentAssignments;
